import { useEffect, useState } from "react";
import React from "react";
import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker"; // Import react-datepicker
import "react-datepicker/dist/react-datepicker.css"; 
import "../assets/styles/PoleInformation.scss";

const ConfirmPoleRepaireWithDate: React.FC<propTypes> = (props: propTypes) => {
    const {handleReplacePole, ...rest} = props;

    const [selectedDateTime, setSelectedDateTime] = useState<Date | null>(null); // Use Date type for selectedDateTime
    const [flag, setFlag] = useState(false);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    useEffect(() => {
        if (window.innerWidth < 991) {
			setFlag(true);
		}
    }, []);

    const onClose = () => {
        setSelectedDateTime(null);
        props.onHide(); 
    }

    return (
        <Modal {...rest} data-testid="ConfirmPoleStatusModal" centered={flag === true} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <h5 className="modal-title" id="staticBackdropLabel">Replace Pole</h5>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="row align-items-center">
                <label className="col-5" htmlFor="datePickerInput">Replace Date and Time</label>
                <div className="col-7">
                <DatePicker
                    id="datePickerInput"
                    data-testid="datePickerInput"
                    selected={selectedDateTime}
                    onChange={(date: Date | null) => setSelectedDateTime(date)}
                    showTimeInput
                    timeInputLabel="Time:"
                    dateFormat="MM-dd-yyyy h:mm aa"
                    className="form-control-sm border border-1"
                    placeholderText="MM-DD-YYYY"
                    maxDate={new Date()}
                    maxTime={selectedDateTime && selectedDateTime.toDateString() === today.toDateString() ? new Date() : new Date(new Date().setHours(23, 59, 59, 999))}
                    minTime={new Date(new Date().setHours(0, 0, 0, 0))}
                    filterDate={(date) => {
                        const selectedDate = new Date(date);
                        selectedDate.setHours(0, 0, 0, 0);
                        return selectedDate <= today;
                    }}
                />
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button type="button" data-testid="cancle-btn" className="btn btn-secondary" onClick={onClose}>Cancel</button>
                <button 
                    type="button"
                    disabled={!selectedDateTime}
                    data-testid="submit-btn" className="btn btn-primary"
                    onClick={() => {handleReplacePole(selectedDateTime); setSelectedDateTime(null);}}
                >
                    Submit
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export type propTypes = {
    status?:{ isResolved: boolean, repairId: number },
    handleReplacePole: (a) => void,
    onHide: () => void,
    show: boolean
};

export default ConfirmPoleRepaireWithDate;